import type { ThemeOptions } from '@material-ui/core/styles';

import jerryTheme from './jerry';

export default {
  palette: jerryTheme.palette,
  typography: jerryTheme.typography,

  /** Global CSS */
  overrides: {
    ...jerryTheme.overrides,
    MuiCssBaseline: {
      '@global': {
        body: {
          scrollBehavior: 'smooth',
          margin: 0,
          WebkitTapHighlightColor: 'transparent',
          backgroundColor: '#fff',
        },
        '.progressBarContainer': {
          height: '4px !important',
        },
        '.global-body-container': {
          justifyContent: 'left !important',
        },
        '.stepBodyContainer': {
          paddingTop: '1rem !important',
        },
        '.step-title': {
          fontSize: '24px !important',
        },
      },
    },
    MuiButton: {
      ...(jerryTheme.overrides?.MuiButton || {}),
      outlined: {
        ...(jerryTheme.overrides?.MuiButton?.outlined || {}),
        borderColor: '#D9E0E9',
      },
    },
  },
} as ThemeOptions;
